import { onSubmitFactory as onUserDirectorySubmit } from "./login";

export const onLoginSubmitFactory = ({
  history,
  initUser = () => {},
  userPool,
  from
}) =>
  onUserDirectorySubmit({
    history,
    initUser,
    userPool,
    from
  });
